import React from 'react';
import { VIDEOS } from '../mock';

export default function VideoSection() {
  return (
    <section className="gradient-bg-purple relative py-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-heading font-extrabold text-white text-3xl md:text-4xl mb-10 leading-snug">
          Veja, em um vídeo, o quão completa é a ADP!
        </h2>
        <div className="rounded-2xl overflow-hidden shadow-2xl bg-black relative" style={{ aspectRatio: '16/9' }}>
          <iframe
            className="w-full h-full absolute inset-0"
            src={`https://www.youtube.com/embed/${VIDEOS.main}`}
            title="Como estudar para a OBMEP"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <p className="mt-10 text-white/90 text-lg">Mas se você não quiser ver o vídeo, vamos lá!</p>
      </div>
      <div className="wave-divider-bottom">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
          <path d="M0,32 C240,72 480,72 720,48 C960,24 1200,24 1440,56 L1440,80 L0,80 Z" fill="#f6e6ff"></path>
        </svg>
      </div>
    </section>
  );
}
